export interface IQuestionForm extends Omit<IQuestion, "ID"> {}

export enum QUESTION_TYPES {
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE"
}

export enum TEST_STATUSES {
  NOT_STARTED = "notStarted",
  COMPLETE_WITH_ERROR = "completeWithError",
  COMPLETE_SUCCESSFUL = "completeSuccessful"
}

export interface IAnswer {
  ID: string;
  Description: string;
  IsCorrect: boolean;
}

export interface IAnswersResult {
  [key: string]: boolean | undefined | string | null;
}

export interface IQuestion {
  ID: string;
  Type: QUESTION_TYPES;
  Description: string;
  Answers: IAnswer[];
}

export interface ITesting {
  Questions: IQuestion[];
  IsQuestionFormOpen: boolean;
  MinCorrectAnswersCount: number;
}
